var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerElectricityStorageUnitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#000000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000, 25.000) scale(0.025000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M661.54-90.39v-112.69h-80.77l117.69-186.53v112.69h80.77L661.54-90.39ZM357.69-160Zm-60 60v-690.38h108.46V-860h147.7v69.62h108.46v314.23q-16 .77-30.81 3.5-14.81 2.73-29.19 7.8v-265.92H357.69V-160h98.23q6.08 17.23 14.31 32.04 8.23 14.8 19.62 27.96H297.69Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerElectricityStorageUnitIcon);
export default __webpack_public_path__ + "static/media/marker-electricityStorageUnit-icon.b8590bde7a56fdfa9b827c9c404d361e.svg";
export { ForwardRef as ReactComponent };